import AddProductActionButton from './AddProductActionButton'

export default AddProductActionButton
